import state from "./modulePaymentManagementState";
import mutations from "./modulePaymentManagementMutations";
import actions from "./modulePaymentManagementActions";

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
